<template>
    
    <div class="single_module" v-if="!!params.list && params.list.length>0">
        <div class="media-title" v-if="params.title_box">
            <div class="title-txt">
                {{params.title}}
            </div>
            <div class="title-more" @click="onClick(params.link)" v-if="params.more_box">
                {{params.more}}
            </div>
        </div>
        <div class="media-content">
           <waterfall :col='col' :width="itemWidth"  :data="list"  :gutterWidth="5"    >
            <template v-for="(item,index) in list" >
              <div v-if="item.has_img" class="content-li" :key="index" @click="gotoAnswer(item)" >
                  <div><img class="content-img" v-if="item.images[0]" :src="item.images[0]" alt="加载错误"  /> </div>
                  <div class="content-text  ">{{item.content}}</div>
                  <div class="bottom">
                    <div class="user-info">
                    <img class="user-img" :src="item.photo"   />
                    <div class="user-username" >{{item.user_name}}</div>
                    </div>
                    <div class="user-count" >
                    <span class="count" >{{item.favor_count}}</span>
                    <span class="iconfont iconzan1"></span>
                    </div>
                  </div>
              </div>
              <div v-else class="content-li" :class="[item.theme]" :key="index" :theme="item.theme" @click="gotoAnswer(item)" >
                  <div class="content-text2 " :style="{'-webkit-line-clamp':item.line}" :class="{'font-size-white':item.theme=='theme_bg_default'?false:true}" >{{item.content}}</div>
                  <div class="course_zone" v-if="item.theme!='theme_bg_default'?false:true" >
                    <img class="course_cover" :src="item.course_cover_url"   />
                    <div class="course_name">{{item.course_name}}</div>
                  </div>

                  <div class="bottom">
                    <div class="user-info">
                    <img class="user-img" :src="item.photo"   />
                    <div class="user-username" :class="{'font-size-white':item.theme=='theme_bg_default'?false:true}" >{{item.user_name}}</div>
                    </div>
                    <div class="user-count" >
                    <span class="count" :class="{'font-size-white':item.theme=='theme_bg_default'?false:true}" >{{item.favor_count}}</span>
                    <span class="iconfont iconzan1" :class="{'font-size-white':item.theme=='theme_bg_default'?false:true}"></span>
                    </div>
                  </div>
               </div>
            </template>
          </waterfall>
             
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { Image as VanImage } from 'vant';
    import waterfall from 'vue-waterfall2'
    Vue.use(waterfall)
    export default {
        name: "reply_module",
        computed:{
          itemWidth(){  

             // 兼容处理，由于插件必须指定像素
            var reply_width = 167
            var initFontSize = 37.5
            var iPhone6Width = 375
            var clientWidth = window.document.documentElement.clientWidth || iPhone6Width
            var newFontSize = initFontSize * (clientWidth / iPhone6Width)
            if(clientWidth!=iPhone6Width){
              reply_width = newFontSize*reply_width/initFontSize
            }
            return reply_width 
          },
          gutterWidth(){
            return (9*0.5*(document.documentElement.clientWidth/375))	
          },
	      },
        data(){
            return {
                col: 2,
                list:[],
                themes:[
                  'theme_bg_green',
                  'theme_bg_default',
                  'theme_bg_default',
                  'theme_bg_red',
                  'theme_bg_default',
                  'theme_bg_default',
                  'theme_bg_blue',
                  'theme_bg_default',
                  'theme_bg_default',
                  ]
            }
        },
        props:{
            params:Object
        },
        created(){
            this.params.list.forEach((element,index) => {
              //var i = Math.floor(Math.random()*4)
              if(!element.has_img){
                var i = index%9
                element.theme = this.themes[i]
                if(element.theme=='theme_bg_default'){
                  element.line = this.lineclamp()
                }
              }
             
            });
            this.list = this.params.list
        },
        components:{
            [VanImage.name]:VanImage,
        },
        methods: {
            onClick(link) {
                // this.util.carouselUrl(link);
                // this.$router.push(link);
                // this.$router.push("train/h5/more_list/replys"+'?token='+this.util.token);
                this.$router.push(this.util.urlPrefix+'/more_list/replys?token='+this.util.token);
            },
            gotoAnswer(item){
              this.$router.push(this.util.urlPrefix+'/course_task/answer_detail?work_answer_id='+item.work_answer_id+'&token='+this.util.token);
            },
            lineclamp(){
              var num =[5,7,8,10]
              var index = Math.floor(Math.random()*4)
              var line = num[index]
              return line
           }
        },
    }
</script>

<style scoped>
    .single_module{
      width: 100%;
      /*margin-top: 10px;*/
      margin: 10px 0;
    }
    .single_module .media-title .title-txt{
      max-width: 80%;
      font-size: 16px;
      font-weight: bold;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      color: #171717;
    }
    .single_module .media-title .title-more{
      float: right;
      color: #327CE9;
      font-size: 12px;
      margin-top: 2px;
    }
    .single_module .media-title{
        background-color: #fff;
    }
    .single_module .media-title .title-txt,.single_module .media-title .title-more{
        display: inline-block;
        vertical-align: middle;
    }
    .single_module .media-content{
      /* padding-top: 5px; */
      padding-bottom: 10px;
    }
    .single_module .media-content .content-li{
        box-sizing: border-box;
        padding: 5px;
        border-radius: 5px;
        box-shadow: 1px 1px 4px 3px rgba(0, 0, 0, 0.05);
        background-color: #FFF;
        margin-top: 5px;
    }

    .single_module .media-content{
      width: 100%;
      background-color: #fff;
      flex-wrap: wrap;
    }
    .content-img{
      width: 100%;
      max-height: 240px;
    }
    .content-text{
      overflow:hidden; 
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:2; 
      font-size: 12px;
      letter-spacing: 1px;
      line-height: 18px;
      margin-top: 4px;
      color: #676565;
    }
    .user-info{
      display: flex;
    }
    .user-username{
      margin-left: 5px;
      font-size: 11px;
      color: rgb(116, 114, 114);
    }
    .bottom{
      height: 21px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 8px;
    }
    .count{
      font-size: 11px;
      color: rgb(116, 114, 114);
    }
    .user-count .iconzan1{
      padding-left: 3px;
      color: rgb(116, 114, 114);
      font-size: 12px;
    }
    .user-img{
      width: 15px;
      height: 15px;
      border-radius: 50%;
    }

    .media-content >>> .vue-waterfall{
      padding-bottom: 8px;
    }
    .content-text2{
      overflow:hidden; 
      text-overflow:ellipsis;
      display:-webkit-box; 
      -webkit-box-orient:vertical;
      -webkit-line-clamp:10; 
      font-size: 12px;
      letter-spacing: 1px;
      line-height: 18px;
      margin-top: 4px;
      color: #676565;
    }
    .course_zone{
      margin-top: 8px;
      display: flex;
      box-sizing: border-box;
    }
    .course_cover{
      width: 81px;
      height: 46px;
    }
    .course_name{
      padding-left: 5px;
      font-size: 11px;
      color: #968e8e;
      line-height: 16px;
    }
    .theme_bg_red{
      background-image: linear-gradient(#e66465, #e85464);
    }
    .theme_bg_green{
      background-image: linear-gradient(#31af66, #5dc1ab);
    }
    .theme_bg_blue{
      background-image: linear-gradient(#6051e4, #5562eb);
    }
    .font-size-white{
      color: #FFF  !important;
    }
    .media-content >>> #vueWaterfall{
      padding-left: 5px;
      padding-right: 5px;
      box-sizing: border-box;
    }

</style>
